// import {PaginationConfig} from "antd/lib/pagination";
import {TablePaginationConfig} from "antd/lib/table";

export const getPagination = ({pagination, defaultSize}: {pagination: TablePaginationConfig; defaultSize: number}) => {
    const {current, pageSize} = pagination;

    if (current && pageSize) {
        const offset = (current - 1) * pageSize;
        const limit = pageSize;

        return {limit, offset};
    }

    return {limit: defaultSize, offset: 0};
};

/**
 * Berechnet die initiale Seitenzahl für eine Tabelle basierend auf der ersten gebuchten Kurseinheit.
 * Hilfreich bei Kursen mit vielen Einheiten, um direkt zur ersten gebuchten Einheit zu springen.
 *
 * @param params - Parameter-Objekt
 * @param params.courseLessons - Array aller Kurseinheiten (chronologisch sortiert)
 * @param params.bookedCourseLessons - Array der gebuchten Kurseinheiten mit courseLessonId
 * @param params.pageSize - Anzahl der Einträge pro Seite
 * @returns Die Seitenzahl (1-basiert), auf der sich die erste gebuchte Einheit befindet, oder 1 als Fallback
 */
export const calculateInitialPageForBookedLessons = <TLesson extends {id: string}, TBookedLesson extends {courseLessonId: string}>({
    courseLessons,
    bookedCourseLessons,
    pageSize,
}: {
    courseLessons: Array<TLesson>;
    bookedCourseLessons: Array<TBookedLesson>;
    pageSize: number;
}): number => {
    // Fallback auf Seite 1, wenn keine gebuchten Kurseinheiten vorhanden sind
    if (bookedCourseLessons.length === 0) {
        return 1;
    }

    // Finde den Index der ersten gebuchten Kurseinheit im courseLessons Array
    const firstBookedIndex = courseLessons.findIndex((lesson) => bookedCourseLessons.some((booked) => booked.courseLessonId === lesson.id));

    // Fallback auf Seite 1, wenn keine Übereinstimmung gefunden wurde
    if (firstBookedIndex === -1) {
        return 1;
    }

    // Berechne die Seitenzahl (1-basiert)
    // Math.floor(index / pageSize) + 1 ergibt die richtige Seite
    return Math.floor(firstBookedIndex / pageSize) + 1;
};
